
    import './styles.scoped.css';
    export default {
  "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_44rcm_3",
  "enable-motion": "awsui_enable-motion_lm6vo_44rcm_3",
  "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_44rcm_4",
  "layout-main-inner": "awsui_layout-main-inner_lm6vo_44rcm_22",
  "root": "awsui_root_lm6vo_44rcm_38",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_44rcm_39",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_44rcm_45",
  "layout": "awsui_layout_lm6vo_44rcm_22",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_44rcm_56",
  "layout-main": "awsui_layout-main_lm6vo_44rcm_22",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_44rcm_66",
  "refresh": "awsui_refresh_lm6vo_44rcm_69",
  "unfocusable": "awsui_unfocusable_lm6vo_44rcm_76",
  "drawer": "awsui_drawer_lm6vo_44rcm_80",
  "drawer-mobile": "awsui_drawer-mobile_lm6vo_44rcm_86",
  "drawer-closed": "awsui_drawer-closed_lm6vo_44rcm_89",
  "drawer-refresh": "awsui_drawer-refresh_lm6vo_44rcm_92",
  "drawer-hidden": "awsui_drawer-hidden_lm6vo_44rcm_104",
  "has-divider-with-splitpanel": "awsui_has-divider-with-splitpanel_lm6vo_44rcm_107",
  "opaque-background": "awsui_opaque-background_lm6vo_44rcm_110",
  "drawer-content": "awsui_drawer-content_lm6vo_44rcm_114",
  "toggle": "awsui_toggle_lm6vo_44rcm_155",
  "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_44rcm_160",
  "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_44rcm_164",
  "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_44rcm_167",
  "button-toggles-container": "awsui_button-toggles-container_lm6vo_44rcm_177",
  "button-toggles-container-is-hidden": "awsui_button-toggles-container-is-hidden_lm6vo_44rcm_182",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_44rcm_196",
  "breadcrumbs-desktop-refresh": "awsui_breadcrumbs-desktop-refresh_lm6vo_44rcm_200",
  "breadcrumbs-desktop-refresh-with-notifications": "awsui_breadcrumbs-desktop-refresh-with-notifications_lm6vo_44rcm_207",
  "breadcrumbs-desktop-sticky-header": "awsui_breadcrumbs-desktop-sticky-header_lm6vo_44rcm_210",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_44rcm_214",
  "content-header-wrapper-refresh": "awsui_content-header-wrapper-refresh_lm6vo_44rcm_217",
  "content-header-wrapper-overlapped": "awsui_content-header-wrapper-overlapped_lm6vo_44rcm_220",
  "content-wrapper": "awsui_content-wrapper_lm6vo_44rcm_224",
  "content-wrapper-refresh": "awsui_content-wrapper-refresh_lm6vo_44rcm_227",
  "content-refresh": "awsui_content-refresh_lm6vo_44rcm_233",
  "content-refresh-overlapped": "awsui_content-refresh-overlapped_lm6vo_44rcm_236",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_44rcm_240",
  "content-wrapper-first-child": "awsui_content-wrapper-first-child_lm6vo_44rcm_243",
  "content-header-wrapper-first-child": "awsui_content-header-wrapper-first-child_lm6vo_44rcm_243",
  "navigation-toggle": "awsui_navigation-toggle_lm6vo_44rcm_248",
  "tools-toggle": "awsui_tools-toggle_lm6vo_44rcm_253",
  "navigation": "awsui_navigation_lm6vo_44rcm_248",
  "navigation-close": "awsui_navigation-close_lm6vo_44rcm_265",
  "tools": "awsui_tools_lm6vo_44rcm_253",
  "tools-close": "awsui_tools-close_lm6vo_44rcm_277",
  "notifications": "awsui_notifications_lm6vo_44rcm_281",
  "breadcrumbs": "awsui_breadcrumbs_lm6vo_44rcm_196",
  "content": "awsui_content_lm6vo_44rcm_214",
  "hide": "awsui_hide_lm6vo_44rcm_302",
  "mobile": "awsui_mobile_lm6vo_44rcm_312",
  "open": "awsui_open_lm6vo_44rcm_318",
  "navigation-panel-exit-state": "awsui_navigation-panel-exit-state_lm6vo_44rcm_323"
};
  